import { Fragment, useCallback, useMemo } from "react";
import { Select } from "../../components";
import { useFormatMessage } from "../../i18n";

export function ControlSelect({
  controls = [],
  formik,
  disabled,
  deviceSelected,
  loading,
}) {
  const tr = useFormatMessage();

  const filterControlsBySelectedType = useCallback(
    (controls) => {
      return controls.filter((control) => {
        return control.possible_types.includes(parseInt(formik.values.type));
      });
    },
    [formik.values.type]
  );

  function mapZonesWithControls() {
    const selectedTypeControls = filterControlsBySelectedType(controls);
    const zones = deviceSelected?.zones.map((zone) => {
      return {
        ...zone,
        sections: zone.sections.map((section) => {
          return {
            ...section,
            controls: selectedTypeControls.filter(
              (control) =>
                control.zoneId === zone.id && control.sectionId === section.id
            ),
          };
        }),
      };
    });
    return zones;
  }

  const zonesWithControls = useMemo(mapZonesWithControls, [
    controls,
    deviceSelected?.zones,
    filterControlsBySelectedType,
  ]);

  function mapControlsIntoOptions() {
    const controlsOptions = zonesWithControls?.map((zone) => {
      return (
        zone.sections.find(({ controls }) => controls.length) && (
          <Fragment key={zone.id}>
            <optgroup label={zone.name || zone.id} />
            {zone.sections.map((section) => {
              return (
                section.controls.length && (
                  <optgroup
                    label={`\u00A0\u00A0 ${tr("page")} ${section.name || section.id}`}
                    key={`${zone.id}-${section.id}`}
                  >
                    {section.controls.map((control) => (
                      <option value={JSON.stringify(control)} key={control.id}>
                        {control.name}
                      </option>
                    ))}
                  </optgroup>
                )
              );
            })}
          </Fragment>
        )
      );
    });
    return controlsOptions;
  }

  function placeHolder() {
    return formik.values.type ? (
      <option>{tr("no_controls_available")}</option>
    ) : (
      <option>{tr("please_select_a_type")}</option>
    );
  }
  const availableOptions = useMemo(mapControlsIntoOptions, [
    tr,
    zonesWithControls,
  ]);

  return (
    <Select
      name="control"
      onChange={formik.handleChange}
      options={
        !filterControlsBySelectedType(controls).length
          ? placeHolder()
          : availableOptions
      }
      optionsState={formik.values.control}
      loading={loading}
      disabled={disabled}
    />
  );
}
